// src/components/Registration.js
import React from 'react';
import './Registration.css';

const Registration = () => {
  return (
    <div className="registration-section">
      <h1 className="registration-title">REGISTRATION FEES</h1>

      <table className="registration-table">
        <thead>
          <tr>
            <th>Fees</th>
            <th>Academic / University</th>
            <th>Private Sector Professional</th>
            <th>Master's and PhD Student</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Fees">Registration before September 20, 2026</td>
            <td data-label="Academic / University">200 Euros</td>
            <td data-label="Private Sector Professional">250 Euros</td>
            <td data-label="Master's and PhD Student">100 Euros</td>
          </tr>
          <tr>
            <td data-label="Fees">Registration after September 20, 2026</td>
            <td data-label="Academic / University">250 Euros</td>
            <td data-label="Private Sector Professional">300 Euros</td>
            <td data-label="Master's and PhD Student">120 Euros</td>
          </tr>
        </tbody>
      </table>

      <div className="payment-method-box">
        <h2 className="payment-title">
          <span className="highlight">Note</span>
        </h2>
        <p className="payment-description">
          These registration fees entitle the participant to attend all conference sessions and presentations, receive all event documentation, and include meals (coffee breaks and lunch) during the congress.
        </p>
      </div>

      <div className="payment-method-box">
        <h2 className="payment-title">Payment Methods</h2>
        <p className="payment-description">
          To validate your participation in the congress, please pay the registration fees before October 15, 2026. Payment must be made via:
        </p>
        <div className="payment-list-container">
          <p><strong>Bank Transfer:</strong></p>
          <ul className="payment-list">
            <li><strong>Bank: </strong>SAHAM BANK</li>
            <li><strong>Account Holder: </strong>Mr. Noursaid Tligui</li>
            <li><strong>RIB: </strong>022 810 0001 3800 2889 8074 23</li>
            <li><strong>BIC/SWIFT: </strong>SGMBMAMC</li>
            <li><strong>IBAN: </strong>MA02 2810 0001 3800 2889 8074 23</li>
          </ul>
        </div>
        <p className="payment-note">
          After payment, please upload your proof of payment in the Booking section below to confirm your registration.<br /><br />
          Registration fees include access to all congress sessions, coffee breaks, lunch, and the participant kit.
        </p>
      </div>
    </div>
  );
};

export default Registration;